(function () {
  'use strict';

  // ---------- Fade-in observer ----------
  var fadeEls = document.querySelectorAll('[data-fade-in]');
  if (fadeEls.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(function (el) { observer.observe(el); });
  }

  // ---------- Tab switching ----------
  var tabs = document.querySelectorAll('.faq-tab');
  var groups = document.querySelectorAll('.faq-group');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = this.getAttribute('data-tab');

      tabs.forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('is-active');
      this.setAttribute('aria-selected', 'true');

      groups.forEach(function (g) {
        if (g.getAttribute('data-tab-content') === target) {
          g.classList.add('is-active');
        } else {
          g.classList.remove('is-active');
        }
      });
    });
  });

  // ---------- Accordion ----------
  var items = document.querySelectorAll('.faq-item');

  items.forEach(function (item) {
    var btn = item.querySelector('.faq-item__button');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      // Close all open items in the same group
      var group = item.closest('.faq-group');
      if (group) {
        group.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
          openItem.classList.remove('is-open');
          openItem.querySelector('.faq-item__button').setAttribute('aria-expanded', 'false');
        });
      }

      // Toggle current item
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

})();